<template>
  <div class="container-fluid fixed-bottom d-md-none d-lg-none d-xl-none nav305 d-print-none">
    <div class="row d-flex flex-row justify-content-center nav305-wrapper m-0 py-2 w-100">


      <slot name="p-1"></slot>

      <div class=" nav-305-item-1 col  d-flex flex-column text-center align-items-center"
           data-toggle="modal"
           :data-target="`${navDataToggle}`">
        <m-icon class="p-0   nav305-nav-icon"
                icon="list"/>
        <span class="nav305-navigation-name " v-t="`nav.side_toggler`"></span>
      </div>

      <teleport to="body">

        <div class="modal right fade" id="nav-305-menu" data-backdrop="static" data-keyboard="false" tabindex="-1"
             aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="px-3 py-2">
                  <m-menu1 :menu-position="menuPosition" id="nav305-menu"/>
                </div>
              </div>
            </div>
          </div>
        </div>

      </teleport>

      <div v-if="shoppingCartToggleTo != null"
           class=" nav-305-item-2 col d-flex  flex-column text-center align-items-center">
        <a v-if="isAuth  || findAttributeOnSiteInfo('cartType') == 1" class="position-relative col-12"
           href="javascript:void(0)"
           data-toggle="modal" :data-target="`${shoppingCartToggleTo}`">
          <m-icon class="p-0  nav305-nav-icon" icon="cart-fill"/>
          <span class="nav305-navigation-name" v-t="`nav.shopping_cart`"></span>
          <m-shopping-cart-counter1 class="position-absolute "/>
        </a>
        <a v-else href="javascript:void(0)" class="position-relative col-12" data-toggle="modal"
           :data-target="`${shoppingCartToggleTo}`">
          <m-icon class="p-0  nav305-nav-icon" icon="cart-fill"/>
          <span class="nav305-navigation-name" v-t="`nav.shopping_cart`"></span>
          <m-shopping-cart-counter1 class="position-absolute "/>
        </a>
      </div>
      <div v-else class="nav-305-item-2 col d-flex  flex-column text-center align-items-center">
        <router-link class="position-relative col-12" v-if="isAuth  || findAttributeOnSiteInfo('cartType') == 1"
                     :to="{name:'ShoppingCart'}">
          <m-icon class="p-0  nav305-nav-icon" icon="cart-fill"/>
          <span class="nav305-navigation-name" v-t="`nav.shopping_cart`"></span>
          <m-shopping-cart-counter1 class="position-absolute "/>
        </router-link>
        <router-link v-else :to="{name:'UnAuthenticatedShoppingCart'}" class="position-relative col-12">
          <m-icon class="p-0  nav305-nav-icon" icon="cart-fill"/>
          <span class="nav305-navigation-name" v-t="`nav.shopping_cart`"></span>
          <m-shopping-cart-counter1 class="position-absolute "/>
        </router-link>
      </div>

      <slot name="p-2"></slot>

      <div class="nav-305-item-3 col d-flex flex-column  text-center align-items-center">
        <router-link :to="{name:'Home'}" class="col-12">
          <m-icon class="p-0  nav305-nav-icon" icon="house-fill"/>
          <span class="nav305-navigation-name" v-t="`nav.home`"></span>
        </router-link>
      </div>
      <div v-if="activeSms" class="nav-305-item-4 col  d-flex flex-column text-center align-items-center">
        <a :href="`sms:${findAttributeOnSiteInfo('cell_phone')[0]};?&body=${smsBody()}`" class="col-12">
          <m-icon class="p-0  nav305-nav-icon" icon="chat-fill"/>
          <span class="nav305-navigation-name" v-t="`nav.send_sms`"></span>
        </a>
      </div>
      <div class=" nav-305-item-5 col d-flex flex-column text-center align-items-center">
        <a href="javascript:void(0)" class="col-12" @click="goBack">
          <m-icon class="p-0  nav305-nav-icon" icon="arrow-left-circle-fill"/>
          <span class="nav305-navigation-name" v-t="`nav.back`"></span>
        </a></div>

      <slot name="p-3"></slot>


    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import mIcon from '../../Icons/Icon'
import mA from '../../Tags/A'
import mMenu1 from "../../Menu/BaseMenu";
import {MenuProps} from "../../Menu/MenuProps";
import mShoppingCartCounter1 from "../../ShoppingCart/ShoppingCartCounter/ShoppingCartCounter1";

export default {
  name: "Nav305",
  components: {mShoppingCartCounter1, mIcon, mA, mMenu1},
  props: {
    shoppingCartToggleTo: {
      default: null
    },
    activeSms: {
      type: Boolean,
      default: false
    },
    navDataToggle: {
      options: ['#nav-305-menu', '#nav200-modal'],
      default: '#nav-305-menu',
    },
    ...MenuProps
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    smsBody() {
      return `سلام....`
    },
  },
  computed: {
    ...mapGetters({
      isAuth: "User/isAuthenticated",
      storeMenus: "Menu/getAllMenus",
    }),
  },
};
</script>

<style>
#nav305-menu, #nav305-menu .dropdown-item {
  text-align: center;
}

#nav305-menu .base-menu-item-wrapper {
  margin: 15px 0;
}

</style>
<style scoped>
.nav305-nav-icon {
  font-size: 20px;
}


.hover-on-text * {
  padding: 5px;
  transition: all ease-in-out .5s;
  font-weight: bold !important;
}

.nav305-navigation-name {
  font-size: 9px;
  display: block;
  text-align: center;
}

.nav305 {
  width: 100%;
}

.modal.left .modal-dialog,
.modal.right .modal-dialog {
  position: fixed;
  margin: auto;
  max-width: 450px;
  width: 320px;
  height: 100%;
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

.modal.left .modal-content,
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.left .modal-body,
.modal.right .modal-body {
  padding: 15px 15px 80px;
}
</style>
